// 商品模板的一些配置选项
const Options = {
  tabs: [
    { value: 'basic-configuration', label: '基本配置' },
    // { value: 'jump-setup', label: '跳过配置' },
    // { value: 'property', label: '属性预设' }
  ],
  category: [
    { value: 0, label: '自动匹配类目', tip: '会有匹配不上类目的情况' },
    { value: 1, label: '跳过未匹配上的', tip: '指的是当匹配不上类目时，铺货预览时不会获取该商品数据' },
    { value: 2, label: '手动指定类目', tip: '手动选择一个当前店铺里已开通的类目', isCascader: true }
  ],
  brand: [
    { value: 0, label: '固定无品牌', tip: '任意商品都是固定使用无品牌' },
    { value: 2, label: '手动指定品牌', tip: '通过搜索出来的品牌不一定是店铺审核通过的品牌，建议选择一个类目，选完类目出现的品牌是已审核通过的' }
  ],
  presellType: [
    { value: 0, label: '现货发货模式' },
  ],
  deliveryDelayDay: [
    { value: 1, label: '24小时' },
    { value: 2, label: '48小时发' }
  ],
  presellEndType: [
    { value: 1, label: '指定天数' },
    { value: 0, label: '选择时间' }
  ],
  presellSpec: [
    { value: '当日发/次日发' },
    { value: '次日发' },
    { value: '48小时内发货' },
    { value: '5天内发货' },
    { value: '15天内发货' }
  ],
  price: {
    platform: [
      // { 
      //   value: '淘特', 
      //   key: 'ttPriceType', 
      //   list: [
      //     { value: 0, label: '特价' }, { value: 1, label: '活动价' }, { value: 2, label: '参考价' }
      //   ] 
      // },
      { 
        value: '1688', 
        key: 'alPriceType', 
        list: [
          { value: 0, label: '代发价' }, { value: 1, label: '批发价' }
        ] 
      }
    ],
    setDecimal: [
      { value: 0, label: '与上游一致' }, { value: 1, label: '不保留小数' },
      { value: 2, label: '保留1位小数' }, { value: 3, label: '保留2位小数' }
    ]
  },
  stock: {
    modifyType: [
      { value: 1, label: '修改库存' }, { value: 0, label: '统一库存为' }
    ],
    calcType: [
      { value: 0, label: '增加' }, { value: 1, label: '减少' }
    ]
  },
  reduceType: [
    { value: 1, label: '下单减库存' }, { value: 2, label: '付款减库存' }
  ],
  supply7dayReturn: [
    { value: 1, label: '支持7天无理由退货' }, { value: 0, label: '不支持7天无理由退货' }
  ],
  commitType: [
    { value: true, label: '立即上架' }, { value: false, label: '放入草稿箱' }
  ],
  isRepeat: [
    { value: true, label: '允许发布相同的商品' }, { value: false, label: '不允许发布相同的商品' }
  ],
  isFolt: [
    {value: 0, label:'否'},{value:1,label:"是"}
  ],
  weightUnit: [
    { value: 0, label: 'kg' }, { value: 1, label: 'g' }
  ],
  titleMoreDeleteType: [
    { value: 0, label: '不操作' }, { value: 2, label: '删除前面的' }, { value: 1, label: '删除后面的' }
  ],
  skuCode: [
    { value: 0, label: '不使用来源信息'},
    { value: 1, label: '来源商品id' },
    { value: 2, label: '来源商品id + 规格1 + 规格2'}
  ]
}

// 创建商品模板的默认参数
function getCreateTemplateParams() {
  return {                           
    presellType: 0, // 发货模式
    deliveryDelayDay: 1, // 发货时间 1
    autoMatchBrand:true,  // 1
    presellDelay: null,
    reduceType: 1, // 减库存类型,  
    supply7dayReturn: 1, // 售后服务-支持7天无理由退货  1
    presellEndType: 1, // 预售结束-指定天数
    standardBrandId: 0, // 默认是无品牌 1
    standardBrandName: '无品牌', // 默认是无品牌 1
    standardBrandType: 0, // 默认是无品牌
    customStandardBrand_id: null, // 手动指定品牌
    setCatType: 0, // 类目 默认选择自动匹配类目  1
    isCommit: false, // 默认放入草稿箱, 
    skuOnsaleStatus: 0, //默认SKU直接上架
    componentTemplateId: null, // 尺码模板ID
    category: [], /// 默认分类是空数组
    priceRatio: null, // 价格倍数  1
    isRepeat: false, // 是否允许发布相同的商品 默认不允许
    setDefaultAndUse: false, // 是否设置为默认模板
    weight: 1, // 商品重量 默认1    1
    weightUnit: 0, // 商品重量单位 默认 kg    1
    stockModifyType: 1, // 默认修改原库存  1
    stockCalcType: 0, // 原库存增加  1
    stockModifyNum: null, // 修改库存  1
    defaultStock: null, // 统一库存为 1
    ttPriceType: 0, // 淘特价格类型  // 1
    alPriceType: 0, // 1688价格类型, 默认代发价  1
    skuLowPriceStatus: false, // 是否启用SKU低价引流方式 1
    skuNumLow: null, // SKU数量大于 1
    firstSkuStock: null, // 设置第一个SKU库存为 1
    firstPriceRatio: null, // 设置第一个SKU价格倍数 1
    firstAddMoney: null, // 设置第一个SKU价格递增数 1
    titlePrefix: '', // 添加标题前缀  1
    titleSuffix: '', // 添加标题后缀  1 
    keywordDel: '', // 删除标题关键字 1
    keywordWaitReplace: '', // 标题待替换 1
    keywordReplace: '', // 标题替换为 1
    keywordReplaceArr: [{ oldValue: '', newValue: '' }],
    titleMoreSixtyDeleteType: 1, // 标题超过60个字符后操作 (默认删除后面的)  1
    skuKeywordDel: '', // 删除sku关键字 1
    skuKeywordWaitReplace: '', // sku待替换 1
    skuKeywordReplaceArr: [{ oldValue: '', newValue: '' }],
    skuKeywordReplace: '', // sku替换为 1
    setDecimal: 0, // 价格 小数处理 (默认与上游一致) 1
    // skip_has_brand: false, // 跳过有品牌的商品 默认不跳过
    // skip_stock_low: null, // 跳过库存小于XX的
    // skip_price_less: null, // 跳过价格小于XX的
    // skip_price_more: null, // 跳过价格大于XX的
    // skip_title_has_keywords: null, // 跳过标题中含有指定的关键词, 逗号拼接
    // skip_sku_has_keywords: null, // 跳过sku中含有指定的关键词, 逗号拼接
    // skip_brand_has_keywords: null // 跳过品牌中含有指定的关键词, 逗号拼接
  }
}

export { Options, getCreateTemplateParams }